import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import BundleCourseFixedGlanceSection from './BundleCourseFixedGlanceSection';

import ProductCustomGlance from '@components/store/product/productCustomGlance';
import ProductCustomGlanceSkeleton from '@components/store/product/productCustomGlance/productCustomGlanceSkeleton';
import ProductDescription from '@components/store/product/productDescription';
import useCourseDetail from '@hooks/course/useCourseDetail';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type BundleCourseDescriptionProps = {
  courseDetailSeo: CourseEntity;
};

const BundleCourseDescription: FC<BundleCourseDescriptionProps> = ({ courseDetailSeo }) => {
  const { t } = useTranslation('store_course');

  const { isCourseDetailLoading, isCourseDetailSeoLoading } = useCourseDetail();

  return (
    <>
      <Box>
        <Typography variant="h4">{t('course_detail.course_description.title')}</Typography>
        <Divider sx={{ marginTop: 2 }} />
      </Box>

      <Box gridColumn={{ lg: '2/3' }} gridRow={{ lg: '1/3' }}>
        <BundleCourseFixedGlanceSection />
      </Box>

      <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
        {isCourseDetailSeoLoading ? (
          <ProductCustomGlanceSkeleton />
        ) : (
          <ProductCustomGlance idName={courseDetailSeo.idName} />
        )}

        <ProductDescription
          description={courseDetailSeo?.description}
          seoDescription={courseDetailSeo?.seoEnable ? courseDetailSeo?.seoDescription : undefined}
          commercialMessage={courseDetailSeo?.commercialMessage}
          isDetailLoading={isCourseDetailLoading}
        />
      </Box>
    </>
  );
};

export default BundleCourseDescription;
